const { h, render, Component } = require('preact');
const Article = require('./article')
const Helper = require('./helper')

class ArticlesList extends Component {
  constructor(props) {
    super(props);
    this.hideArticleById = this.hideArticleById.bind(this);
    this.showArticleById = this.showArticleById.bind(this);
  }

  componentDidMount() {
    Helper.closeOpenedArticles()
  }

  componentDidUpdate(prevProps){
      if ((this.props.searchText !== prevProps.searchText)) {
        this.setState({openedContentId: null});
        let articlesCollapsed = document.getElementsByClassName("article-collapsed");
        let articlesExpanded = document.getElementsByClassName("article-expanded");

        for (let i = 0; i < articlesCollapsed.length; ++i) {
          articlesExpanded[i].setAttribute("style", "display: none");
          articlesCollapsed[i].setAttribute("style", "display: block");
        }
      }

  }

  getExpandedArticle(contentId){
    return document.getElementById(`${contentId}-expanded`);
  }

  getCollapsedArticle(contentId){
    return document.getElementById(`${contentId}-collapsed`);
  }

  hideArticleById(contentId){
    if(contentId){
      this.getExpandedArticle(contentId).setAttribute("style", "display: none");
      this.getCollapsedArticle(contentId).setAttribute("style", "display: block");
    }
  }

  showArticleById(contentId){
    if(contentId){
      this.hideArticleById(this.state.openedContentId);
      this.setState({openedContentId: contentId});

      this.getCollapsedArticle(contentId).setAttribute("style", "display: none");
      this.getExpandedArticle(contentId).setAttribute("style", "display: block");
    }
  }

  populateArticles(){
    let articles = [];
    this.props.articles.forEach(article => {
      articles.push(<Article
                      article={article}
                      hideArticleById={this.hideArticleById.bind(this)}
                      showArticleById={this.showArticleById.bind(this)}
                      handleNeedHelpFromSearchResults={this.props.handleNeedHelpFromSearchResults}
                      onGuestHelp={this.props.onGuestHelp}
                      showGuestHelp={this.props.showGuestHelp}
                    />);
    });
    return articles;
  }

  render() {
    if (this.props.articles && this.props.articles.length > 0){
      return (
        <ul class={"search-articles-list " + this.props.additionalProperties}>
          {this.populateArticles()}
        </ul>
      );
    }
    return null;
  }
}
module.exports = ArticlesList
